export const calculateHolland = (answers) => {
  // 1. MESLEK VERİTABANI (Hangi tip hangi işi yapar?)
  const CAREER_MAP = {
    'Gerçekçi (R)': {
        desc: "Pratik, madde odaklı ve sabırlısınız. El becerileriniz yüksek.",
        jobs: ["Mühendislikler (Makine/İnşaat/Bilgisayar)", "Mimarlık", "Diş Hekimliği", "Pilotaj", "Gastronomi", "Veterinerlik", "Askeri Personel", "Ziraat Müh.", "Teknisyenlik"]
    },
    'Araştırmacı (I)': {
        desc: "Analitik, meraklı ve bilimsel düşünceye sahipsiniz.",
        jobs: ["Tıp (Doktorluk)", "Eczacılık", "Yazılım Müh.", "Psikoloji", "Genetik", "Matematik", "Akademisyenlik", "Ekonomi", "Fizik/Kimya", "Sosyoloji"]
    },
    'Sanatsal (A)': {
        desc: "Yaratıcı, sezgisel ve ifade yeteneği güçlü birisiniz.",
        jobs: ["Grafik Tasarım", "İç Mimarlık", "Radyo-TV Sinema", "Reklamcılık", "Yazarlık", "Müzisyenlik", "Moda Tasarımı", "Oyunculuk", "Halkla İlişkiler", "Görsel İletişim"]
    },
    'Sosyal (S)': {
        desc: "Yardımsever, iletişimci ve insan odaklısınız.",
        jobs: ["Psikolojik Danışmanlık (PDR)", "Öğretmenlik", "Hukuk", "Hemşirelik", "Sosyal Hizmetler", "İnsan Kaynakları", "Çocuk Gelişimi", "Fizyoterapi", "Diyetisyenlik"]
    },
    'Girişimci (E)': {
        desc: "İkna kabiliyeti yüksek, lider ruhlu ve girişken.",
        jobs: ["Avukatlık/Savcılık", "İşletme/Yöneticilik", "Siyaset Bilimi", "Uluslararası İlişkiler", "Pazarlama", "Girişimcilik", "Lojistik", "Turizm İşletmeciliği", "Endüstri Müh."]
    },
    'Geleneksel (C)': {
        desc: "Düzenli, titiz, planlı ve kuralcı bir yapınız var.",
        jobs: ["Bankacılık", "Muhasebe/Finans", "Kamu Yönetimi", "Arşivcilik", "Maliye", "Noterlik", "Büro Yönetimi", "İstatistik", "Sigortacılık", "Vergi Uzmanlığı"]
    }
  };

 // 2. EŞLEŞTİRME (Orijinal test kağıdına göre kalibre edildi, 79 eklendi, her grup tam 15 soru!)
  const MAPPING = {
    'Gerçekçi (R)': [9, 13, 19, 25, 26, 38, 40, 52, 53, 54, 59, 61, 70, 82, 84], 
    'Araştırmacı (I)': [1, 3, 4, 8, 11, 17, 22, 34, 39, 41, 47, 48, 68, 71, 80],
    'Sanatsal (A)': [6, 10, 14, 31, 32, 42, 44, 45, 50, 62, 72, 74, 77, 78, 81],
    'Sosyal (S)': [2, 21, 29, 37, 49, 55, 58, 60, 64, 65, 66, 73, 87, 88, 90],
    'Girişimci (E)': [7, 15, 16, 18, 20, 28, 33, 35, 51, 56, 63, 67, 75, 83, 85],
    'Geleneksel (C)': [5, 12, 23, 24, 27, 30, 36, 43, 46, 57, 69, 76, 79, 86, 89]
  };

  let scores = { 'Gerçekçi (R)': 0, 'Araştırmacı (I)': 0, 'Sanatsal (A)': 0, 'Sosyal (S)': 0, 'Girişimci (E)': 0, 'Geleneksel (C)': 0 };

  // 3. HESAPLAMA (Likert: 2-1-0 Puan)
  Object.keys(answers).forEach(key => {
    const qId = parseInt(key);
    let points = 0;
    if (typeof answers[key] === 'number') {
        points = answers[key];
    } else if (answers[key] === true || answers[key] === "true") {
        points = 2; // Eski usül "Evet" ise tam puan
    }

    if (points > 0) {
      for (const [type, ids] of Object.entries(MAPPING)) {
        if (ids.includes(qId)) scores[type] += points;
      }
    }
  });

  // 4. SIRALAMA VE SONUÇ
  const sortedScores = Object.entries(scores).sort((a, b) => b[1] - a[1]);
  const top3 = sortedScores.slice(0, 3);
  const code = top3.map(s => s[0].split('(')[1].replace(')', '')).join('-'); // Örn: R-I-S
  const dominantType = top3[0][0];


  // 🌟 ÖĞRENCİYE GÖSTERİLECEK KISA VE YAŞA UYGUN GERİ BİLDİRİM
  const STUDENT_FEEDBACK_MAP = {
    'Gerçekçi (R)': {
      headline: 'Gerçekçi İlgi Alanı',
      message:
        'Pratik işler, araçlar, makineler, teknoloji veya somut bir şey üretmek ilgini çeken alanlar arasında olabilir. Bir şeyi yalnızca öğrenmekten çok, onu uygulayarak görmek sana daha yakın gelebilir.'
    },

    'Araştırmacı (I)': {
      headline: 'Araştırmacı İlgi Alanı',
      message:
        'Merak etmek, neden-sonuç ilişkilerini çözmek, araştırmak ve karmaşık problemlerin üzerinde düşünmek sana çekici geliyor olabilir. Bilimsel ve analitik alanlar ilgini besleyebilir.'
    },

    'Sanatsal (A)': {
      headline: 'Sanatsal İlgi Alanı',
      message:
        'Yeni fikirler üretmek, kendini özgün biçimde ifade etmek, tasarlamak veya estetik yönü olan çalışmalar yapmak sana yakın olabilir. Yaratıcılığını kullanabildiğin ortamlar ilgini artırabilir.'
    },

    'Sosyal (S)': {
      headline: 'Sosyal İlgi Alanı',
      message:
        'İnsanlarla iletişim kurmak, birilerine yardımcı olmak, öğretmek, dinlemek veya birlikte çalışmak ilgini çeken alanlar arasında olabilir. İnsan odaklı ortamlar sana daha anlamlı gelebilir.'
    },

    'Girişimci (E)': {
      headline: 'Girişimci İlgi Alanı',
      message:
        'İnsanları etkilemek, bir fikri savunmak, sorumluluk almak, organizasyon yapmak veya liderlik etmek sana çekici geliyor olabilir. Hareketli ve inisiyatif kullanabileceğin ortamlar ilgini artırabilir.'
    },

    'Geleneksel (C)': {
      headline: 'Geleneksel İlgi Alanı',
      message:
        'Planlı çalışmak, bilgileri düzenlemek, ayrıntılarla ilgilenmek ve işlerin belirli bir sistem içinde ilerlemesi sana uygun geliyor olabilir. Düzen ve organizasyon gerektiren alanlarda kendini rahat hissedebilirsin.'
    }
  };



  // Meslekleri Birleştir (1. Tipten 6 tane + 2. Tipten 4 tane al)
  const primaryJobs = CAREER_MAP[top3[0][0]].jobs.slice(0, 6);
  const secondaryJobs = CAREER_MAP[top3[1][0]].jobs.slice(0, 4);
  const suggestedJobs = [...primaryJobs, ...secondaryJobs];

  // SİHİRLİ DOKUNUŞ: Dinamik Adil Yüzde Hesaplama Motoru
  const chartData = Object.keys(scores).map(key => {
    // O kategorideki soru sayısını bul (örn: 16) ve 2 ile çarp (maksimum alınabilecek puan)
    const maxPossibleScore = MAPPING[key].length * 2; 
    
    // Alınan puanı maksimum puana bölüp yüzdeye çevir
    const percentage = (scores[key] / maxPossibleScore) * 100;

    return { 
  subject: key.split(' ')[0],

  // Ham puan: örn. 21 / 30
  rawScore: scores[key],
  maxScore: maxPossibleScore,

  // Alanın kendi maksimumuna göre ilgi düzeyi: örn. %70
  A: Math.round(percentage),

  fullMark: 100 
};
  });

  // --- YENİ EKLENEN STANDART PAKETLEME (ZARF) ---
  // Holland bir "Risk" testi değil, Mesleki İlgi "Profil" testidir.
  // En baskın alanın yüzdesini riskScore (eşleşme gücü) olarak gönderiyoruz.
  const topPercentage = chartData.find(c => c.subject === dominantType.split(' ')[0])?.A || 0;

  const dominantFeedback =
    STUDENT_FEEDBACK_MAP[dominantType];

  const top3Labels = top3.map(([type]) =>
    type.replace(/\s*\([A-Z]\)$/, '')
  );

  const studentFeedback = {
    eyebrow: "MESLEKİ İLGİ PROFİLİN",
    title: "Kendinle İlgili Küçük Bir Keşif",
    headline:
      dominantFeedback?.headline ||
      "Mesleki İlgi Profilin",

    highlights: top3Labels,

    message:
      dominantFeedback?.message ||
      "Yanıtların, bazı mesleki ilgi alanlarının diğerlerinden daha fazla öne çıktığını gösteriyor.",

    counselorNote:
      "Bu sonuç tek başına bir meslek seçimi anlamına gelmez. İlgi alanlarını; yeteneklerin, değerlerin, hedeflerin ve eğitim seçeneklerinle birlikte psikolojik danışmanınla değerlendirmen en sağlıklı sonucu verir.",

    btnText: "Sonucumu Gördüm"
  };

  return {
    // 1. Ortak Dil (StudentFolders burayı okuyacak)
    riskScore: topPercentage, // En baskın alanın uyum yüzdesi
    masterRisk: "none",       // Radar ekranında acil uyarı vermemesi için
    isCritical: false, 
    domain: "profile",        // Bu bir profil/ilgi testi

    // 2. Mevcut Detaylı Veriler (Dashboard, Pusula ve PDF için dokunmadık)
    summary: `HOLLAND KODU: ${code}`,
    analysis: CAREER_MAP[dominantType].desc,
    chartData: chartData,
    suggestedJobs: suggestedJobs,
colorCode: "blue",

// 🌟 Öğrenci test sonrası mini sonuç ekranı
studentFeedback: studentFeedback
  };
};